<div class="grid-y bold-text">
  <div [ngClass]="change| defineDomainViewCss: 'name': 'contact'">{{contactVO?.name| displayValueFromChange :'name': change :'contact'}}</div>
  <div [ngClass]="change| defineDomainViewCss: 'organizationName': 'contact'">{{contactVO?.organizationName| displayValueFromChange :'organizationName': change :'contact'}}</div>
  <div class="multi-line"
    [ngClass]="change| defineDomainViewCss: 'address-streetAddress': 'contact'">{{contactVO?.address?.streetAddress| displayValueFromChange :'address-streetAddress': change :'contact'}}</div>
  <div>
    <span [ngClass]="change| defineDomainViewCss: 'address-city': 'contact'">{{contactVO?.address?.city| displayValueFromChange :'address-city': change :'contact'}}</span>
    &nbsp;
    <span [ngClass]="change| defineDomainViewCss: 'address-state': 'contact'">{{contactVO?.address?.state| displayValueFromChange :'address-state': change :'contact'}}</span>
    &nbsp;
    <span
      [ngClass]="change| defineDomainViewCss: 'address-postalCode': 'contact'">{{contactVO?.address?.postalCode| displayValueFromChange :'address-postalCode': change :'contact'}}</span>
  </div>
  <div
    [ngClass]="change| defineDomainViewCss: 'address-countryName': 'contact'">{{contactVO?.address?.countryName| displayValueFromChange :'address-countryName': change :'contact'}}</div>
  <div [ngClass]="change| defineDomainViewCss: 'phone': 'contact'">{{contactVO?.phone| displayValueFromChange :'phone': change :'contact'}}</div>
  <div [ngClass]="change| defineDomainViewCss: 'fax': 'contact'">{{contactVO?.fax| displayValueFromChange :'fax': change :'contact'}}</div>
  <div [ngClass]="change| defineDomainViewCss: 'email': 'contact'">{{contactVO?.email| displayValueFromChange :'email': change :'contact'}}</div>

  <div class="grid-x last-update-button-section">
    <label>{{lastchange | lastChange}}</label>
    <button *ngIf="!viewMode" class="iana-button" (click)="onEdit()" [disabled]="!(pendingRequestChangeID | checkNull) || !hasNonTechnicalPermission" id="update">Modify</button>
  </div>

</div>

